// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3XznO","title":"AfterBackImages_title__3zaZQ","images":"AfterBackImages_images__1YnJo"};